const $ = window.$;
// attaches to file upload control/upload button and manages
// validation and submission.
export default function FileUpload(id, settings) {
	this.id = id;
	this.$outer;
	this.$upload;
	this.$submit;

	var _s = settings || {};

	var _MAX_INDIVIDUAL_SIZE = 6; // in megabytes
	var _MAX_TOTAL_SIZE = 10; // in megabytes
	var _badFiles = [];
	var _totalSize = 0;
	var _isInit = false;

	var _showErrorMessage = function() {
		var strMessage = '';
        // this serves as primary individual and total upload size checking.
        // sizes are also checked server-side for most upload pages using Global.asax though
        // uploads on ExpRptAppr.aspx are handled internally due to query string persistence issues
		if (_badFiles.length > 0) {
		    strMessage = '<div>'
		    return async_translate('The following files exceed the individual maximum file size of')
		        .then(function(strTran) {
		            strMessage += strTran + ' ' + _MAX_INDIVIDUAL_SIZE + ' MB.';

		            return async_translate('Please try again without these files');
		        })
		        .then(function(strTran) {
		            strMessage += ' ' + strTran + '.</div>';
		        })
		        .then(function(strTran) {
		            strMessage += '<div style="margin-top:10px">'
		            _badFiles.forEach(function(file, i) {
		                if (i !== 0) strMessage += '<br>' 
		                strMessage += '- ' + file.name
		            });

		            strMessage += '</div>'

		            return async_translate('Upload Cancelled')
		        })
		        .then(function(strTran) {
		            alertModal.setTitleText(strTran);
		            alertModal.setMessageText(strMessage);
		            // just say that it was triggered by the body to make the JS happy.
		            // these simple alerts don't need to know any information about the node
		            // that activated them.
		            alertModal.open($('body'));
		            alertModal.$outer.find('.js-ok').focus();
		        })
		}

		if (_totalSize > _MAX_TOTAL_SIZE) {
			return window.async_translate('The combined size of the files you\'ve selected exceeds the upload limit. Please reduce the upload size and try again.')
				.then(function(strTran) {
					strMessage = strTran + '<div style="margin-top:10px">';
					return window.async_translate('Upload Limit');
				})
				.then(function(strTran) {
					strMessage += '<strong>' + strTran + ': </strong> ' + _MAX_TOTAL_SIZE + ' MB<br>';
					return window.async_translate('Upload Size');
				})
				.then(function(strTran) {
					strMessage += '<strong>' + strTran + ': </strong> ' + _totalSize.toFixed(2) + ' MB</div>';

					return window.async_translate('Upload Cancelled');
				})
				.then(function(strTran) {
					window.alertModal.setTitleText(strTran);
					window.alertModal.setMessageText(strMessage);
					// just say that it was triggered by the body to make the JS happy.
					// these simple alerts don't need to know any information about the node
					// that activated them.
					window.alertModal.open($('body'));
					window.alertModal.$outer.find('.js-ok').focus();
				});
		}
	};

	var _processFiles = function(files) {
		var len = files.length;
		var i = 0;
		var file;
		var size;
		_totalSize = 0;
		_badFiles = [];

		for (i; i < len; i++) {
			file = files[i];
			size = file.size / 1024 / 1024;
			if (size >= _MAX_INDIVIDUAL_SIZE) {
				_badFiles.push(file);
			}
			_totalSize += size;
		}

		return _badFiles.length === 0 && _totalSize <= _MAX_TOTAL_SIZE;
	};

	var _cacheSelectors = function() {
		this.$outer = $('#' + id);
		this.$upload = this.$outer.find('.js-file-upload');
		this.$submit = this.$outer.find('.js-file-upload-submit');
	};

	var _attachEvents = function() {
		var that = this;
		$(document).on('change', '.js-file-upload', function() {
			var booSuccess = _processFiles(this.files);

			if (!booSuccess) {
				_showErrorMessage();
				that.disableSubmit();
				that.$upload[0].value = '';
				return;
			}

			that.enableSubmit();

			if (_s.autoSubmit) {
				if (typeof _s.autoSubmitHandler === 'function') {
					_s.autoSubmitHandler(that);
				} else {
					that.submit();
				}
			}
		});


		$(document).on('click', '.js-file-upload-trigger', function() {
			that.$upload.trigger('click');
		});

		$(document).on('click', '.js-file-upload-submit', function() {
			window.applyLoadingState(30);
		});
	};

	this.enableSubmit = function() {
		this.$submit
			.prop('disabled', false)
			.removeClass('btn--disabled');
	};

	this.disableSubmit = function() {
		this.$submit
			.prop('disabled', true)
			.addClass('btn--disabled');
	};

	this.submit = function() {
		this.$submit.trigger('click');
	};

	
	this.init = function () {
		// do not initialize if no outer elem found.
		if (!$('#' + this.id).length) return;

		_cacheSelectors.call(this);

		if (!_isInit) {
			_attachEvents.call(this);
		}

		// if the upload input has a value assigned at page load, enable the submit button
		if (this.$upload[0].value) {
			this.enableSubmit();
		}

		_isInit = true;
	};

}
